/*
 *
 *  SightingMobileGrid
 *
 */

import React from 'react';
import PropTypes from 'prop-types';

import AdvancedMobileGrid from 'containers/AdvancedMobileGrid';

import { DOCUMENTS_FOR_MY_VISA, MY_AGREEMENT_HISTORIES } from "../../../domain/Data/Filters/constants";
import {
    addActionButton,
} from '../common/actionButton';
import {
    agreeActionItem,
    disagreeActionItem,
    viewActionItem,
    editActionItem,
} from '../common/actionMenu';

import { SIGHTING_DOCUMENTS_DX_GRID } from './constants';

import { getRowHeight, RowComponent } from "../common/mobile";
import { statusColorLabels } from "../common/mobile/mobileStatusLabels";
import { columnType } from "../../../domain/typeConstants/table";

class SightingMobileGrid extends React.Component {
    getFilters() {
        const { viewName } = this.props;
        const filters = [];
        if (viewName === 'resultOfAgreement') filters.push(MY_AGREEMENT_HISTORIES);
        if (viewName === 'forMyVisa') filters.push(DOCUMENTS_FOR_MY_VISA);
        return filters;
    }

    getDetailRowFields() {
        return [
            {
                path: 'number',
                name: 'number',
                title: '№',
            },
            {
                path: 'state',
                name: 'state.name',
                title: 'Состояние',
                getValue: (row) => row.state ? row.state.name : undefined,
                labels: statusColorLabels,
                type: columnType.LABEL,
            },
            {
                path: 'actualCreationDate',
                name: 'actualCreationDate',
                title: 'Дата',
                type: 'date',
            },
            {
                path: 'category',
                name: 'category.name',
                title: 'Тип',
                getValue: (row) => (row.category ? row.category.name : undefined),
            },
            {
                path: 'company',
                name: 'company_name',
                getValue: (row) => (row.company ? row.company.name : undefined),
                title: 'Контрагент',
            },
            {
                path: 'content',
                name: 'content',
                title: 'Содержание',
                type: columnType.TEXT,
            },
            {
                path: 'amount',
                name: 'amount',
                title: 'Сумма',
            },
        ];
    }

    getActionButtons() {
        return [addActionButton];
    };

    getActionMenuItems() {
        return [
            agreeActionItem,
            disagreeActionItem,
            viewActionItem,
            editActionItem,
        ];
    };

    getSorting() {
        return [{ columnId: 'actualCreationDate', columnName: 'actualCreationDate', direction: 'desc' }];
    };

    render() {
        const { onActionExecuting, viewName } = this.props;

        return (
            <AdvancedMobileGrid
                entityName='documents'
                name={SIGHTING_DOCUMENTS_DX_GRID}
                actionButtons={this.getActionButtons()}
                actionMenuItems={this.getActionMenuItems()}
                detailRowFields={this.getDetailRowFields()}
                filters={this.getFilters()}
                getRowHeight={getRowHeight}
                onActionExecuting={onActionExecuting}
                rowComponent={RowComponent}
                sorting={this.getSorting()}
                viewName={viewName}
            />
        );
    }
}

SightingMobileGrid.propTypes = {
    onActionExecuting: PropTypes.func,
    viewName: PropTypes.string,
};

export default SightingMobileGrid;
